import { render, staticRenderFns } from "./AddToWishlist.vue?vue&type=template&id=ab0e9922&"
import script from "./AddToWishlist.vue?vue&type=script&lang=js&"
export * from "./AddToWishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab0e9922')) {
      api.createRecord('ab0e9922', component.options)
    } else {
      api.reload('ab0e9922', component.options)
    }
    module.hot.accept("./AddToWishlist.vue?vue&type=template&id=ab0e9922&", function () {
      api.rerender('ab0e9922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/themes/default/components/core/blocks/Wishlist/AddToWishlist.vue"
export default component.exports